<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="COMMON.PRODUCTS"
    descriptionKey="ADMIN.IA.PRODUCTS.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="product?.name || ''"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    @if (loading) {
      <app-admin-state-panel
        mode="loading"
        titleKey="COMMON.LOADING"
      ></app-admin-state-panel>
    } @else if (hasError || !product) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.PRODUCTS.ERROR.LOAD"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <app-admin-form-layout>
        <app-form-products [payload]="product" [showIntro]="false" [onUpdate]="reload"></app-form-products>
      </app-admin-form-layout>
    }
  </div>
</section>
